import React from 'react'
import { NavBarScreen } from '../navBar/NavBarScreen'
import { FooterScreen } from '../footer/FooterScreen'

const TermsAndCinditions = () => {
    return (
        <>
            <NavBarScreen />
            <br />
            <br />
            <br />
            <br />

            <div className="terminos-container">
                <h1>🏕️ TÉRMINOS Y CONDICIONES DE PARTICIPACIÓN</h1>
                <p><strong>¡Bienvenido a la aventura con Camping Chimborazo!</strong></p>

                <p>
                    Camping Chimborazo es una operadora de turismo especializada en experiencias de trekking, senderismo y camping en entornos de alta y media montaña. Nuestras actividades se desarrollan en espacios naturales que, si bien ofrecen paisajes únicos y experiencias enriquecedoras, también pueden presentar condiciones cambiantes y ciertos riesgos inherentes.
                </p>

                <p>
                    Por ello, la participación en cualquiera de nuestras rutas implica la aceptación expresa de los siguientes términos y condiciones, los cuales han sido elaborados para garantizar tu seguridad, fomentar una experiencia responsable y establecer de manera clara los compromisos entre el participante y Camping Chimborazo.
                </p>

                <h2>1. 🙋 Participación informada y voluntaria</h2>
                <p>Las actividades organizadas por Camping Chimborazo se desarrollan en entornos naturales de alta y media montaña, los cuales ofrecen experiencias únicas, pero también pueden presentar condiciones impredecibles. Al participar, el cliente acepta que pueden presentarse situaciones como:</p>
                <ul>
                    <li>🌧️ Cambios repentinos en el clima</li>
                    <li>🪨 Terrenos irregulares o de difícil acceso</li>
                    <li>🧗‍♀️ Exigencia física moderada a alta</li>
                    <li>🎒 Pérdida, daño o extravío de objetos personales</li>
                </ul>
                <p>
                    Nuestro equipo aplica protocolos de seguridad y planificación en cada recorrido. Sin embargo, al tratarse de ambientes naturales, existen riesgos inherentes que el participante asume al decidir formar parte de la actividad.
                </p>
                <p>
                    ➡️ Por lo tanto, el participante libera expresamente a Camping Chimborazo, sus guías, colaboradores y terceros vinculados, de toda responsabilidad por daños físicos, materiales o morales que pudieran surgir antes, durante o después de la actividad.
                </p>

                <h2>2. 💪 Tu bienestar es clave</h2>
                <p>Al participar, confirmas que te encuentras en buenas condiciones físicas y mentales para caminar, acampar y explorar con nosotros. Si tienes alguna condición médica, por favor háznoslo saber con anticipación. ¡Nos ayudará a cuidarte mejor!</p>
                <p>🚫 Por seguridad de todos, no se permite participar bajo efectos de alcohol o sustancias.</p>

                <h2>3. 🎒 Prepárate con lo esencial</h2>
                <p>Nuestro equipo te indicará lo que necesitas llevar para cada aventura. Es importante que cuentes con el equipo adecuado y en buen estado, como ropa térmica, calzado resistente, mochila, linterna, etc.</p>
                <p>Si no llevas lo necesario, el guía podrá pedirte no participar por tu propia seguridad.</p>
                <p>⚠️ Recuerda que eres responsable de tus pertenencias durante toda la actividad.</p>

                <h2>4. 🌱 Respeto total: al grupo, al guía y a la naturaleza</h2>
                <ul>
                    <li>Sigue siempre las instrucciones del guía.</li>
                    <li>No te separes del grupo sin avisar.</li>
                    <li>Cuidemos juntos la naturaleza: no dejes basura, no dañes plantas ni molestes a los animales.</li>
                    {/* <li>Actitudes irrespetuosas o peligrosas podrían implicar que te pidamos abandonar la actividad, sin reembolso.</li> */}
                </ul>

                <h2>5. 📅 Cancelaciones y puntualidad</h2>
                <ul>
                    <li>✅ Si necesitas cancelar, hazlo al menos 24 horas antes de la salida para que podamos reprogramarte o devolverte el dinero.</li>
                    <li>❌ Si cancelas fuera de ese tiempo o no te presentas, no podremos hacer devoluciones.</li>
                    <li>⏱️ La puntualidad es muy importante para no afectar al grupo.</li>
                </ul>

                {/* <h2>6. 🧾 Sobre seguros y asistencia</h2>
                <p>En caso de emergencia, siempre actuamos con rapidez y responsabilidad. Aun así, te recomendamos contar con un seguro de salud o accidentes que te respalde durante la actividad, especialmente si visitamos zonas remotas.</p> */}

                <h2>6. 📸 Uso de imágenes</h2>
                <p>Durante las rutas solemos tomar fotos y videos para compartir la belleza del lugar (¡y tu valentía!). Al participar, aceptas que podamos usar ese material en nuestras redes sociales o promociones, siempre con respeto. Si prefieres no aparecer, solo avísanos.</p>

                <h2>7. 🖊️ Firma de consentimiento</h2>
                <p>Antes de comenzar la ruta, te pediremos firmar un documento breve (Acta de Descargo) donde confirmas que leíste y aceptaste estas condiciones. ¡Nada complicado!</p>

                <h2>✅ 8. Confirmación de aceptación</h2>
                <p>➡️ Al contratar un tour con Camping Chimborazo, confirmo que he leído, comprendido y aceptado todos los términos y condiciones aquí descritos.</p>

                <br></br>
                <br></br>
                <h2 style={{textAlign:"center"}}>🚀 ¡Listos para la aventura!</h2>
                <p style={{textAlign:"center"}}>En Camping Chimborazo nos apasiona lo que hacemos y estamos aquí para que vivas una experiencia única, segura y respetuosa con la naturaleza.</p>
                <p style={{textAlign:"center"}}><b>Gracias por elegirnos 💚 ¡Nos vemos en la montaña!</b></p>
            </div>

            <br />


            <FooterScreen />
        </>
    )
}

export default TermsAndCinditions
